import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import CanalesDirectos from "./sections/CanalesDirectos";
import SecureYourTable from "./sections/SecureYourTable";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <CanalesDirectos />
      <SecureYourTable />
      <Footer />
    </div>;
}